import { render, staticRenderFns } from "./a-poppup.vue?vue&type=template&id=3b7c4bee&scoped=true&"
import script from "./a-poppup.vue?vue&type=script&lang=js&"
export * from "./a-poppup.vue?vue&type=script&lang=js&"
import style0 from "./a-poppup.vue?vue&type=style&index=0&id=3b7c4bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c4bee",
  null
  
)

export default component.exports